import ApiService from "./api_service";
export default {
    async get(page, params) {
        return await ApiService.call('get', 'bookings/?page=' + page + '&' + params);
    },
    async get_detail(booking_id) {
        return await ApiService.call('get', 'bookings/' + booking_id + '/');
    },
    async get_confirmation(booking_uuid) {
        return await ApiService.call('get', 'booking-confirmations/' + booking_uuid + '/');
    },
    async post(payload) {
        return await ApiService.call('post', 'bookings/', payload);
    },
    async patch(booking_id, payload) {
        return await ApiService.call('patch', 'bookings/' + booking_id + '/', payload);
    },
    async delete(booking_id) {
        return await ApiService.call('delete', 'bookings/' + booking_id + '/');
    },
    async resend_confirmation_email(booking_id, payload) {
        return await ApiService.call('post', 'bookings/' + booking_id + '/resend-confirmation-email/', payload);
    },
    async resend_key_email(booking_id, payload) {
        return await ApiService.call('post', 'bookings/' + booking_id + '/resend-key-email/', payload);
    },
    async send_payment_reminder_email(booking_id, payload) {
        return await ApiService.call('post', 'bookings/' + booking_id + '/send-payment-reminder-email/', payload);
    },
    async get_for_calendar() {
        return await ApiService.call('get', 'bookings-calendar/');
    },
    async get_price_for_dates(user_id, cabin, start_date, end_date, has_plus_one) {
        return await ApiService.call(
            'get',
            'bookings-get-price/?cabin='+cabin+'&start_date='+start_date+'&end_date='+end_date+'&has_plus_one=' + has_plus_one + (user_id != null ? ('&user_id='+user_id) : '')
        );
    },
    async get_income_for_dates(payed, start_date, end_date) {
        return await ApiService.call(
            'get',
            'bookings-get-income/?payed='+payed+'&from_date='+start_date+'&to_date='+end_date
        );
    },
}